import * as React from "react";

import { App } from "@app/App";
import {
  initializeAnalytics,
  initializeErrorTracking,
  initializePerformanceMonitoring,
} from "@v2/features/infra/analytics/init";

// Import stylesheets
import "./index.scss";
import "./tailwind.css";

import { createRoot } from "react-dom/client";

initializeErrorTracking();
initializeAnalytics();
initializePerformanceMonitoring();

const root = createRoot(document.querySelector("#root") as HTMLElement);
root.render(<App />);
